export const insertDataInDB = (clear, add, customers) => {
  clear().then(() => {
    customers.forEach((item, index) => add({ ...item, Id: index + 1 }));
  });
};
